import {notificationsStore} from "./notificationsStore";
import DOMPurify from "dompurify";
import {marked} from "marked";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	if (!("target" in node)) return;
	node.setAttribute("target", "_blank");
	node.setAttribute("rel", "noreferrer");
});

/** Parse and sanitize markdown */
export const markdown2Html = (input: string) => {
	try {
		const parsed = marked.parseInline(input, {async: false, breaks: true});
		const sanitized = DOMPurify.sanitize(parsed);
		return sanitized;
	} catch (error) {
		console.error("Error parsing/sanitizing markdown:", error);
		return "";
	}
};

/** Convert non-standard locales (xx_XX|en_INT) to BCP47 (xx-XX) or fallback to en-US */
export const toBCP47Locale = (locale: string) => {
	// pass valid BCP47 locales (eg de-AT)
	if (/^[a-z]{2}-[A-Z]{2}$/.test(locale)) return locale;

	// explicitly convert en_INT to en-US
	if (locale === "en_INT") return "en-US";

	// convert Trumpf-style (eg fr_FR to fr-FR)
	if (/^[a-z]{2}_[A-Z]{2}$/.test(locale)) return locale.replace("_", "-");

	// fallback to en-US for anything else
	if (notificationsStore.debugMode) console.warn(`Locale "${locale}" not supported. Falling back to "en-US".`);
	return "en-US";
};
